<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,15C5,15.55,5.45,16,6,16C6,16,10,16,10,16C10.55,16,11,15.55,11,15C11,15,11,14,11,14C11,14,5,14,5,14C5,14,5,15,5,15C5,15,5,15,5,15ZM12,0C12,0,4,0,4,0C3.45,0,3,0.45,3,1C3,1,3,2,3,2C3,2,13,2,13,2C13,2,13,1,13,1C13,0.45,12.55,0,12,0C12,0,12,0,12,0ZM5,7C5,7,5,13,5,13C5,13,11,13,11,13C11,13,11,7,11,7C11,7,13,3,13,3C13,3,3,3,3,3C3,3,5,7,5,7C5,7,5,7,5,7ZM7,7C7,6.45,7.45,6,8,6C8.55,6,9,6.45,9,7C9,7,9,9,9,9C9,9.55,8.55,10,8,10C7.45,10,7,9.55,7,9C7,9,7,7,7,7C7,7,7,7,7,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Torch',
} as DefineComponent
</script>
